import { pool } from '../../ops/pool';
import { getGlobalTensorClass } from '../../tensor';
getGlobalTensorClass().prototype.pool = function (windowShape, poolingType, padding, dilationRate, strides) {
    this.throwIfDisposed();
    return pool(this, windowShape, poolingType, padding, dilationRate, strides);
};
//# sourceMappingURL=pool.js.map